import type { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.js';
import { userErrorBadParam } from '@sola/shared-utils/errors/misc.js';
import { userErrorCommitmentPaymentPlanUpdate } from '@sola/shared-utils/errors/supporters.js';
import { httpPutWithStatus } from '@sola/shared-utils/httpClient.js';

import { MY_API_BASE } from '../constants';

export interface CommitmentPaymentPlanUpdateRes {
  success: boolean;
}

export const routeCommitmentPaymentPlan = (
  supporterId: string,
  commitmentId: string,
) =>
  `${MY_API_BASE}/supporters/${supporterId}/commitments/${commitmentId}/payment-plan/`;

export const updateCommitmentPaymentPlan = async (
  supporterId?: string,
  commitmentId?: string,
  newPaymentMethodId?: GraphQLSupporterPaymentMethod['id'],
  paymentDay?: number,
): Promise<CommitmentPaymentPlanUpdateRes> => {
  if (!supporterId) {
    throw userErrorBadParam('supporterId');
  }

  if (!commitmentId) {
    throw userErrorBadParam('commitmentId');
  }

  if (!newPaymentMethodId) {
    throw userErrorBadParam('newPaymentMethodId');
  }

  const { response, statusCode } =
    await httpPutWithStatus<CommitmentPaymentPlanUpdateRes>(
      routeCommitmentPaymentPlan(supporterId, commitmentId),
      {
        paymentMethodId: newPaymentMethodId,
        paymentPullDayOfMonth: paymentDay,
      },
      {
        signRequest: true,
      },
    );

  if (statusCode !== 200 || !response?.success) {
    throw userErrorCommitmentPaymentPlanUpdate(statusCode);
  }

  return response;
};
